import { computed, inject } from '@angular/core';
import { signalStore, type, withComputed, withMethods } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { SecurityBase } from '@pinnakl/securities/domain';
import { withCallState, withDataService, withDevtools } from '@pinnakl/shared/signal-store';
import { SecuritiesSearchFilter, SecuritySearchResult } from '@pinnakl/shared/types';
import { AssetTypesStore } from '../asset-types';
import { SecurityTypesStore } from '../security-types';
import { SecuritiesApiService, SecuritiesFilter } from './securities-api.service';

const securitiesStoreKey = 'securities';
export const SecuritiesStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withDevtools(securitiesStoreKey),
  withCallState({
    collection: securitiesStoreKey,
  }),
  withEntities({
    entity: type<SecurityBase>(),
    collection: securitiesStoreKey,
  }),
  withDataService<SecurityBase, SecuritiesFilter, SecuritiesApiService, 'securities'>({
    dataServiceType: SecuritiesApiService,
    filter: {},
    collection: securitiesStoreKey,
  }),
  withComputed((store, securityTypesStore = inject(SecurityTypesStore), assetTypesStore = inject(AssetTypesStore)) => ({
    selectedSecurityAssetType: computed(() => {
      const current = store.currentSecurities();
      if (!current) return null;
      const secType = securityTypesStore.securityTypes().find(secType => secType.id === current.secTypeId);
      return secType
        ? (assetTypesStore.assetTypes().find(assetType => assetType.id === secType.assetTypeId) ?? null)
        : null;
    }),
  })),
  withMethods((store, api = inject(SecuritiesApiService)) => ({
    searchSecurities: async (params?: SecuritiesSearchFilter): Promise<SecuritySearchResult[]> => {
      return api.searchSecurities(params);
    },
    loadAffectedSecurityTradesAmount: async (securityId: number): Promise<{ affectedCount: 0 }> => {
      return api.loadAffectedSecurityTradesAmount(securityId);
    },
  })),
);
